/**
 * This page is used by the admin app as part of a flow that allows
 * pre-registered users to login into the app by following a link. The admin
 * app assumes that this page exists at `/pre-registered-user-login`.
 *
 * The hardcoded link to this page is stored in
 * Shared/RepeatMD.Shared/Commands/Admin/Users/CreateCustomPlanCommand.cs
 */

import { type LoaderFunction, redirect } from "react-router-dom";

import { queryClient } from "pages/Root";
import Services from "services/Services";

export const preRegisteredUserLoginLoader: LoaderFunction = async ({
  request,
}) => {
  queryClient.invalidateQueries();
  queryClient.resetQueries();

  const isLoggedIn = await Services.auth.isAuthorized();

  const searchParams = new URL(request.url).searchParams;
  const authToken = searchParams.get("authToken");
  const packageId = searchParams.get("packageId");

  if (!isLoggedIn) {
    if (!authToken) {
      return redirect("/signin");
    }

    await Services.auth.setToken(authToken);
  }

  return redirect(
    packageId ? `/custom-plan/${packageId}` : "/cart/checkout/element"
  );
};
